"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
var ConsigneeRequest;
(function (ConsigneeRequest) {
    var Create = (function (_super) {
        __extends(Create, _super);
        function Create() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = undefined;
            _this.lastName = undefined;
            _this.email = undefined;
            _this.companyName = undefined;
            _this.companyAddress = undefined;
            _this.rut = undefined;
            _this.address = undefined;
            _this.phone = undefined;
            _this.cod = undefined;
            _this.active = undefined;
            _this.facebookId = undefined;
            return _this;
        }
        return Create;
    }(BaseModel_1["default"]));
    ConsigneeRequest.Create = Create;
    var Update = (function (_super) {
        __extends(Update, _super);
        function Update() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.name = undefined;
            _this.lastName = undefined;
            _this.email = undefined;
            _this.companyName = undefined;
            _this.companyAddress = undefined;
            _this.rut = undefined;
            _this.address = undefined;
            _this.phone = undefined;
            _this.cod = undefined;
            _this.active = undefined;
            return _this;
        }
        return Update;
    }(BaseModel_1["default"]));
    ConsigneeRequest.Update = Update;
})(ConsigneeRequest = exports.ConsigneeRequest || (exports.ConsigneeRequest = {}));
var ConsigneeResponse;
(function (ConsigneeResponse) {
    var Consignee = (function (_super) {
        __extends(Consignee, _super);
        function Consignee() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.name = undefined;
            _this.lastName = undefined;
            _this.email = undefined;
            _this.userRoleId = undefined;
            _this.companyName = undefined;
            _this.companyAddress = undefined;
            _this.rut = undefined;
            _this.address = undefined;
            _this.number = undefined;
            _this.apt = undefined;
            _this.city = undefined;
            _this.departament = undefined;
            _this.zip = undefined;
            _this.phone = undefined;
            _this.cod = undefined;
            _this.active = undefined;
            return _this;
        }
        return Consignee;
    }(BaseModel_1["default"]));
    ConsigneeResponse.Consignee = Consignee;
    var FullConsignee = (function () {
        function FullConsignee() {
            this.consignee = undefined;
            this.consigneeBalance = undefined;
        }
        return FullConsignee;
    }());
    ConsigneeResponse.FullConsignee = FullConsignee;
    var All = (function (_super) {
        __extends(All, _super);
        function All(objects, length, offset, pagination) {
            if (length === void 0) { length = 0; }
            if (offset === void 0) { offset = 0; }
            if (pagination === void 0) { pagination = 100; }
            var _this = _super.call(this) || this;
            _this.objects = undefined;
            _this.length = 0;
            _this.offset = 0;
            _this.pagination = 100;
            _this.objects = objects;
            _this.length = length;
            _this.offset = offset;
            _this.pagination = pagination;
            return _this;
        }
        return All;
    }(BaseModel_1["default"]));
    ConsigneeResponse.All = All;
    var Invoice = (function (_super) {
        __extends(Invoice, _super);
        function Invoice() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.number = undefined;
            _this.voucherType = undefined;
            _this.creationDate = undefined;
            _this.expirationDate = undefined;
            _this.amount = undefined;
            _this.outstandingBalance = undefined;
            return _this;
        }
        return Invoice;
    }(BaseModel_1["default"]));
    ConsigneeResponse.Invoice = Invoice;
    var Book = (function (_super) {
        __extends(Book, _super);
        function Book() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.isbn = undefined;
            _this.title = undefined;
            _this.author = undefined;
            _this.editorial = undefined;
            _this.price = undefined;
            _this.balanceConsigned = undefined;
            _this.totalBalance = undefined;
            _this.quantity = undefined;
            return _this;
        }
        return Book;
    }(BaseModel_1["default"]));
    ConsigneeResponse.Book = Book;
})(ConsigneeResponse || (ConsigneeResponse = {}));
exports.ConsigneeResponse = ConsigneeResponse;



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/consignee.js
// module id = ../model/dist/models/consignee.js
// module chunks = main